import { makeStyles } from '@material-ui/core/styles'

export const loginDialogStyle = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  username: {
    width: '100%',
    marginTop: theme.spacing(1)
  },
  password: {
    width: '100%',
    marginTop: theme.spacing(1)
  },
  errorContainer: {
    height: theme.spacing(2.25)
  },
  errorText: {
    fontSize: 12,
    color: '#DE4035'
  },
  title: {
    paddingBottom: 0
  },
  actionsContainer: {
    marginTop: 16
  }
}))
